import {
  mobileNetworkOperatorFilterAtom,
  mnoNamesFilterAtom,
  mobileNetworkOperatorIdFilterAtom,
} from 'atoms/filters/sim';
import { mnoHintsAtom } from 'atoms/hints/sim';
import { MNOSearchFilter } from 'src/common/components/Filters/Inputs/mnos/MNOSearchFilter';

export const MnoSearchInput = () => {
  return (
    <MNOSearchFilter
      mnoFilterAtom={mobileNetworkOperatorFilterAtom}
      mnoNamesFilterAtom={mnoNamesFilterAtom}
      mnoHintsAtom={mnoHintsAtom}
      mnoIdFilterAtom={mobileNetworkOperatorIdFilterAtom}
    />
  );
};
